module.exports = __webpack_public_path__ + "certificaat_les_2_lllmbo.pdf";